// The editor creator to use.
import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
// import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Link from '@ckeditor/ckeditor5-link/src/link';
import List from '@ckeditor/ckeditor5-list/src/list';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';

import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';     // <--- ADDED
import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';        // <--- ADDED
import Table from '@ckeditor/ckeditor5-table/src/table';                 // <--- ADDED
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';   // <--- ADDED
import Font from '@ckeditor/ckeditor5-font/src/font';                    // <--- ADDED

export default class ClassicEditor extends ClassicEditorBase {}

// Plugins to include in the build.
ClassicEditor.builtinPlugins = [
    Essentials,
    // UploadAdapter,
    Autoformat,
    Bold,
    Italic,
    BlockQuote,
    EasyImage,
    Heading,
    Image,
    ImageCaption,
    ImageStyle,
    ImageToolbar,
    ImageUpload,
    Link,
    List,
    Paragraph,
    Alignment,                                                             // <--- ADDED
    CKFinder,                                                              // <--- ADDED
    Table,                                                                 // <--- ADDED
    TableToolbar,                                                          // <--- ADDED
    Font                                                                   // <--- ADDED
];

// Editor configuration.
ClassicEditor.defaultConfig = {
    fontSize: {
        options: [
            'tiny',
            'default',
            'big'
        ]
    },
    toolbar: {
        items: [
            // 'ckfinder',                                                   // <--- ADDED
            // '|',
            'heading',
            '|',
            'fontSize', 'fontColor', 'fontBackgroundColor',                           // <--- ADDED
            '|',
            'bold',
            'italic',
            '|',
            'alignment',                                                  // <--- ADDED
            '|',               
            'bulletedList',
            'numberedList',
            '|',
            'link',
            'blockQuote',
            'insertTable',                                                // <--- ADDED
            '|',
            'undo',
            'redo',
            '|'
        ]
    },
    image: {
        toolbar: [
            'imageStyle:full',
            'imageStyle:side',
            '|',
            'imageTextAlternative'
        ]
    },
    // ckfinder: {
    //     // Upload the images to the server using the CKFinder QuickUpload command.
    //     uploadUrl: '/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Files',

    //     // Define the CKFinder configuration (if necessary).
    //     options: {
    //         resourceType: 'Images'
    //     }
    // },
    table: {
        contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
    },
    // This value must be kept in sync with the language defined in webpack.config.js.
    language: 'en'
};